export default __webpack_public_path__ + "static/media/case2-1 (1).3de84dc1.png";